import { z } from "zod";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedConfFile.errors.";

const destinationCalendarFileSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "destination_calendar_file" }
);
const ticketAutomationReceivedConfFileCalendarSchema = z.object({
  id: z.string(),
  name: z.string(),
});
const tticketAutomationReceivedConfFileCalePreferenceSchema = z.object({
  id: z.string(),
  name: z.string(),
});
const ticketAutomationReceivedConfFileCaleProcedureSchema = z.object({
  id: z.string(),
  name: z.string(),
});
const ticketAutomationReceivedConfFileCaleInsurancesSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  {
    invalid_type_error:
      translationPath + "ticketAutomationReceivedConfFileCaleInsurances",
  }
);
const ticketAutomationReceivedConfFileCaleInsuranceTypesSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  {
    invalid_type_error:
      translationPath + "ticketAutomationReceivedConfFileCaleInsuranceTypes",
  }
);
export const automationReceivedConfFileSchema = z.object({
  id: z.string().optional(),
  automationCode: z.string().optional(),
  destinationCalendarFile: destinationCalendarFileSchema,
  displayOrder: z.string().min(1, translationPath + "displayOrder"),
  waitLimitTime: z.string().optional(),
  message: z.string().min(1, translationPath + "message"),
  messageError: z.string().min(1, translationPath + "messageError"),
  ticketAutomationReceivedConfFileCalendars: z
    .array(ticketAutomationReceivedConfFileCalendarSchema)
    .nullish(),
  ticketAutomationReceivedConfFileCalePreferences: z
    .array(tticketAutomationReceivedConfFileCalePreferenceSchema)
    .nullish(),
  ticketAutomationReceivedConfFileCaleProcedures: z
    .array(ticketAutomationReceivedConfFileCaleProcedureSchema)
    .nullish(),
  ticketAutomationReceivedConfFileCaleInsurances: z
    .array(ticketAutomationReceivedConfFileCaleInsurancesSchema)
    .nullish(),
  ticketAutomationReceivedConfFileCaleInsuranceTypes: z
    .array(ticketAutomationReceivedConfFileCaleInsuranceTypesSchema)
    .nullish(),
});

export type TAutomationReceivedConfFileForm = z.infer<
  typeof automationReceivedConfFileSchema
>;
